import { render, staticRenderFns } from "./TelNgWordsAlertCount.vue?vue&type=template&id=1d0d841c"
import script from "./TelNgWordsAlertCount.vue?vue&type=script&lang=js"
export * from "./TelNgWordsAlertCount.vue?vue&type=script&lang=js"
import style0 from "./TelNgWordsAlertCount.vue?vue&type=style&index=0&id=1d0d841c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports